import { Instant, LocalDateTime, LocalTime, ZoneId, ZonedDateTime } from '@js-joda/core';
import { first, isEmpty } from 'es-toolkit/compat';

const dateTimeFormatTest = /T\d\d:\d\d/;

export const TOCK_TIMEZONE = 'America/Chicago';

export const getTockZoneId = () => ZoneId.of(TOCK_TIMEZONE);

/**
 * Turns a number of different formats into a LocalDateTime object.
 */
export function getLocalDateTime(
  timeValue: string | LocalDateTime | Instant | ZonedDateTime,
  timeZone: string
): LocalDateTime | undefined {
  if (typeof timeValue === 'string') {
    if (!isEmpty(timeValue)) {
      return dateTimeFormatTest.test(timeValue) ? LocalDateTime.parse(timeValue) : undefined;
    }
  } else if (timeValue instanceof Instant) {
    return LocalDateTime.ofInstant(timeValue, ZoneId.of(timeZone));
  } else if (timeValue instanceof ZonedDateTime) {
    return timeValue.toLocalDateTime();
  } else if (timeValue instanceof LocalDateTime) {
    return timeValue;
  }
  return;
}

/**
 * Turns a number of different formats into a LocalTime object.
 */
export function getLocalTime(
  timeValue: string | LocalDateTime | LocalTime | Instant | ZonedDateTime | Date,
  timeZone: string
): LocalTime | undefined {
  if (typeof timeValue === 'string') {
    if (!isEmpty(timeValue)) {
      return dateTimeFormatTest.test(timeValue)
        ? LocalDateTime.parse(timeValue).toLocalTime()
        : LocalTime.parse(timeValue);
    }
  } else if (timeValue instanceof Date) {
    return LocalTime.parse(first(timeValue.toTimeString().split(' ')) || '');
  } else if (timeValue instanceof LocalTime) {
    return timeValue;
  } else {
    return getLocalDateTime(timeValue, timeZone)?.toLocalTime();
  }
  return;
}
